<template>
  <div class = "api-module api-events">
    <p class = "description">
      Este evento se lanza 5 segundos antes de que tu proyecto cambie a otro. Aqui puedes simular el evento pulsando el botón
    </p>
    <!-- This event is triggered 5 seconds before the sketch stop. Here you can simulate that event. -->
    <button class = "btn btn-border-colored btn-round" v-on:click = "sendOnAboutToStop">Enviar señal</button>
  </div>
</template>

<script>
export default {
  name: 'ApiEvents',
  components: {
  },
  props: {
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    sendOnAboutToStop: function () {
      this.$eventHub.$emit('rtdata', { from: 'onAboutToStop', value: 5 })
    }
  },
  mounted () {
  }
}
</script>

<style lang = "less" scoped>
@import (reference) "../../assets/styles/main.less";

.api-events {
  button {
    display: block;
    width: 200px;
    align-self: center;
    margin-top: 50px;
    text-align: center;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/ApiModules/ApiEvents.vue